import React from 'react';

console.log('[ERROR_BOUNDARY] Componente carregado');

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    console.log('[ERROR_BOUNDARY] Constructor executado');
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    console.error('[ERROR_BOUNDARY] getDerivedStateFromError:', error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ERROR_BOUNDARY] componentDidCatch - Error:', error);
    console.error('[ERROR_BOUNDARY] componentDidCatch - ErrorInfo:', errorInfo);
    console.error('[ERROR_BOUNDARY] Stack:', error.stack);
    this.setState({ error, errorInfo });
  }

  render() {
    console.log('[ERROR_BOUNDARY] render() - hasError:', this.state.hasError);
    
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          backgroundColor: '#fee', 
          border: '2px solid red',
          fontFamily: 'monospace',
          margin: '20px'
        }}>
          <h1 style={{ color: 'red' }}>🔴 ERRO CAPTURADO PELO ERROR BOUNDARY</h1>
          <h2>Error:</h2>
          <pre style={{ backgroundColor: '#fff', padding: '10px', overflow: 'auto' }}>
            {this.state.error && this.state.error.toString()}
          </pre>
          <h2>Stack:</h2>
          <pre style={{ backgroundColor: '#fff', padding: '10px', overflow: 'auto' }}>
            {this.state.error && this.state.error.stack}
          </pre>
          <h2>Component Stack:</h2>
          <pre style={{ backgroundColor: '#fff', padding: '10px', overflow: 'auto' }}>
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </pre>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
